import React, {useEffect, useState} from "react";
import axios from "axios";
import {useContext} from "react";
import {MapContext} from "../Context/OptionsApi";
import GraphModal from "./Graph";
import {downloadCSV} from "../Api";
import csv from "./map/icons/csv.svg";
import {AppContext} from "../Context/Context";
import toast from "react-hot-toast";
// import {BsFiletypeCsv} from "react-icons/bs";
// import {GrPowerReset} from "react-icons/gr";
// import barchart from "./map/icons/bar-chart";

const baseURL2 = process.env.REACT_APP_BASE_URL_WEB;

function Options(props) {
    const { filters, setFilters, sowingDate, setSowingDate } = useContext(MapContext);
    const { user } = useContext(AppContext);
    const [noData, setNoData] = useState(false);
    const [noDataMessage, setNoDataMessage] = useState("");

    const handleChange = async (event) => {
        const { name, value } = event.target;

        setFilters((prevFilters) => {
            if (name === "crop") {
                return {
                    ...prevFilters,
                    crop: value,
                    infestation_id: null,
                    state: null,
                    district: null,
                    sub_district: null,
                    villages: null,
                    state_options: [],
                    district_options: [],
                    sub_district_options: [],
                    villages_options: [],
                    lat: 22.150535,
                    lon: 81.556363,
                    zoom: 4,
                };
            }

            if (name === "infest") {
                return {
                    ...prevFilters,
                    infestation_id: value === "" ? null : value,
                    district: null,
                    sub_district: null,
                    villages: null,
                    district_options: [],
                    sub_district_options: [],
                    villages_options: [],
                    lat: 22.150535,
                    lon: 81.556363,
                    zoom: 4,
                };
            }

            if (name === "state") {
                if (value !== "") {
                    const obj = JSON.parse(value);
                    return {
                        ...prevFilters,
                        state: obj,
                        district: null,
                        sub_district: null,
                        villages: null,
                        district_options: [],
                        sub_district_options: [],
                        villages_options: [],
                        lat: obj.state_latitude,
                        lon: obj.state_longitude,
                        zoom: 7,
                    };
                }
                return { ...prevFilters, state: null };
            }

            if (name === "district") {
                if (value !== "") {
                    const obj = JSON.parse(value);
                    return {
                        ...prevFilters,
                        district: obj,
                        sub_district: null,
                        villages: null,
                        sub_district_options: [],
                        villages_options: [],
                        lat: obj.district_latitude,
                        lon: obj.district_longitude,
                        zoom: 9,
                    };
                }
                return { ...prevFilters, district: null };
            }

            if (name === "sub_district") {
                if (value !== "") {
                    const obj = JSON.parse(value);
                    return {
                        ...prevFilters,
                        sub_district: obj,
                        villages: "",
                        lat: obj.sub_district_latitude,
                        lon: obj.sub_district_longitude,
                        zoom: 10,
                    };
                }
                return { ...prevFilters, sub_district: "" };
            }

            if (name === "villages") {
                if (value !== "") {
                    const obj = JSON.parse(value);
                    return {
                        ...prevFilters,
                        villages: obj,
                        lat: obj.village_latitude,
                        lon: obj.village_longitude,
                        zoom: 12,
                    };
                }
                return { ...prevFilters, villages: null };
            }

            return { ...prevFilters, [name]: value };
        });
    };

    const handleDownload = () => {
        downloadCSV(
            filters.state?.state_id,
            filters.infestation_id,
            filters.crop,
            filters.district?.district,
            filters.sub_district?.sub_district
        );
    };

    async function fetchCrops() {
        try {
            const res = await axios.get(`${baseURL2}/api/location/crops`);
            if (res.status === 200) {
                setFilters((prev) => ({
                    ...prev,
                    crop_options: res.data.res || [],
                }));
            }else{
              toast.error("Unexpected status code "+res.status)
            }
        } catch (err) {
            console.error("Error fetching crops:", err.message);
            toast.error(err.response?.data?.error || err.message || "could not fetch crops");
        }
    }

    async function fetchInfests(crop) {
        try {
            const res = await axios.get(`${baseURL2}/api/infestation/cropInfests`, {
                params: { crop },
            });
            if (res.status === 200) {
                let infest_options = res.data?.data;
                if (!infest_options || !Array.isArray(infest_options)) {
                  infest_options = [];
                }
                if (infest_options.length === 0) {
                  setNoData(true);
                  setNoDataMessage("No Infestations found!");
                }
                setFilters((prev) => ({
                    ...prev,
                    infest_options
                }));
            }else{
              toast.error("Unexpected status code "+res.status)
            }
        } catch (err) {
            console.error("Error fetching infestations:", err.message);
            toast.error(err.response?.data?.error || err.message || "could not fetch Infests");
        }
    }

    async function getStates(crop) {
        try {
            const response = await axios.post(`${baseURL2}/api/location/getAvailableLocationbycrops`, { crop_name: crop });
            if (response.status === 200) {
              let state_options = response.data?.res;
              if (!state_options || !Array.isArray(state_options)) {
                state_options = [];
              }
              if (state_options.length === 0) {
                setNoData(true);
                setNoDataMessage("No Infestations found!");
              }
              setFilters((prev) => ({
                ...prev,
                state_options,
              }));
            }else{
              toast.error("Unexpected status code "+response.status)
            }
        } catch (error) {
            console.error("Error fetching getStates :", error.message);
          toast.error(error.response?.data?.error || error.message || "could not fetch states");

        }
    }

    async function getDistricts(state, infestation_id, crop) {
        try {
            const response = await axios.post(`${baseURL2}/api/location/getAvailableLocationbycrops/districts`, {
                state_id: state,
                infestation_id,
                crop_name: crop,
            });
            if (response.status === 200) {
              let district_options = response.data?.districts;
              if (!district_options || !Array.isArray(district_options)) {
                district_options = [];
              }
              if (district_options.length === 0) {
                setNoData(true);
                setNoDataMessage("No Infestations found!");
              }
              setFilters((prev) => ({
                ...prev,
                district_options,
              }));
            }else{
              toast.error("Unexpected status code "+response.status)
            }
        } catch (error) {
            console.error("Error fetching getDistricts :", error.message);
            toast.error(error.response?.data?.error || error.message || "could not get districts");
        }
    }

    async function getSubDistricts(state, infestation_id, crop, districtId) {
        try {
          const url = `${baseURL2}/api/location/getAvailableLocationbycrops/sub_districts`;

          const response = await axios.post(url, {
                crop_name: crop,
                state_id: state,
                district_id: districtId,
                infestation_id,
            });

            if (response.status === 200) {
              let sub_district_options = response.data?.res;
              if (!sub_district_options || !Array.isArray(sub_district_options)) {
                sub_district_options = [];
              }
              if (sub_district_options.length === 0) {
                setNoData(true);
                setNoDataMessage("No Infestations found!");
              }
              setFilters((prev) => ({...prev, sub_district_options}));
            }else{
              toast.error("Unexpected status code "+response.status)
            }
        } catch (error) {
            console.error("Error fetching getSubDistricts :", error.message);
            toast.error(error.response?.data?.error || error.message || "could not get sub districts");
        }
    }

    async function getVillages(state, infestation_id, crop, subDistrictId) {
        try {
            const response = await axios.post(`${baseURL2}/api/location/getAvailableLocationbycrops/villages`, {
                crop_name: crop,
                state_id: state,
                infestation_id,
                sub_district_id: subDistrictId,
            });

            if (response.status === 200) {
              let villages_options = response.data?.res;
              if (!villages_options || !Array.isArray(villages_options)) {
                villages_options = [];
              }
              if (villages_options.length === 0) {
                setNoData(true);
                setNoDataMessage("No Infestations found!");
              }
              setFilters((prev) => ({...prev, villages_options}));
            }else{
              toast.error("Unexpected status code "+response.status)
            }
        } catch (error) {
            console.error("Error fetching villages data:", error.message);
            toast.error(error.response?.data?.error || error.message || "could not get villages");
        }
    }

    useEffect(() => {
        fetchCrops();
    }, []);

    useEffect(() => {
        if (filters.crop) fetchInfests(filters.crop);
    }, [filters.crop]);

    useEffect(() => {
        if (filters.crop && filters.infestation_id) getStates(filters.crop);
    }, [filters.crop, filters.infestation_id]);

    useEffect(() => {
        if (filters.state && filters.infestation_id && filters.crop) {
            getDistricts(filters.state.state_id, filters.infestation_id, filters.crop);
        }
    }, [filters.state, filters.infestation_id, filters.crop]);

    useEffect(() => {
        if (filters.district && filters.infestation_id && filters.crop) {
            getSubDistricts(
                filters.state.state_id,
                filters.infestation_id,
                filters.crop,
                filters.district.district_id
            );
        }
    }, [filters.district, filters.infestation_id, filters.crop]);

    useEffect(() => {
        if (filters.sub_district && filters.infestation_id && filters.crop) {
            getVillages(
                filters.state.state_id,
                filters.infestation_id,
                filters.crop,
                filters.sub_district.sub_district_id
            );
        }
    }, [filters.sub_district, filters.infestation_id, filters.crop]);

    return (
        <div className="px-2 flex gap-10 text-gray-700 font-semibold  mx-5 mb-3 ">
            <div className="flex justify-between items-center gap-3">
                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="crop">
                        CROP
                    </label>
                    <select
                        onChange={handleChange}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                        name="crop"
                        value={filters.crop}
                    >
                        <option value="">Crop</option>
                        {filters.crop_options?.map((c) => (
                            <option key={c.crop_id} value={c.crop_name}>
                                {c.crop_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="infest">
                        INFESTATION
                    </label>
                    <select
                        name="infest"
                        value={filters.infestation_id || ""}
                        onChange={handleChange}
                        disabled={filters.infest_options.length === 0}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                    >
                        <option value="">Infestation</option>
                        {filters.infest_options?.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="flex justify-between items-center gap-3">
                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="country">
                        COUNTRY
                    </label>
                    <select
                        onChange={handleChange}
                        className="w-20  py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100 focus:outline-none focus:border-gray-900"
                        name="India"
                        id="country"
                    >
                        <option value={"India"}>{"India"}</option>
                    </select>
                </div>

                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="state">
                        STATE
                    </label>
                    <select
                        onChange={handleChange}
                        disabled={filters.state_options.length === 0}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                        name="state"
                        value={filters.state ? JSON.stringify(filters.state) : ""}
                    >
                        <option value="">State</option>
                        {filters.state_options?.map((el, i) => (
                            <option key={i} value={JSON.stringify(el)}>
                                {el.state}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="dist">
                        DISTRICT
                    </label>
                    <select
                        onChange={handleChange}
                        disabled={filters.district_options.length === 0}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                        name="district"
                    >
                        <option value="">District</option>
                        {filters.district_options?.map((el, index) => (
                            <option key={index} value={JSON.stringify(el)}>
                                {el.district}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="sub_dist">
                        SUB-DIST.
                    </label>
                    <select
                        onChange={handleChange}
                        disabled={filters.sub_district_options.length === 0}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                        name="sub_district"
                        value={filters.sub_district ? JSON.stringify(filters.sub_district) : ""}
                    >
                        <option value="">Sub-dist</option>
                        {filters.sub_district_options?.map((el, index) => (
                            <option key={index} value={JSON.stringify(el)}>
                                {el.sub_district}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col">
                    <label className="text-[10px] font-normal ml-0.5" htmlFor="village">
                        VILLAGE
                    </label>
                    <select
                        onChange={handleChange}
                        disabled={filters.villages_options.length === 0}
                        className="w-20 py-1 px-1 border text-[12px] border-gray-500 rounded-md bg-gray-100"
                        name="villages"
                        value={filters.villages ? JSON.stringify(filters.villages) : ""}
                    >
                        <option value="">Village</option>
                        {Array.isArray(filters.villages_options) &&
                            filters.villages_options.map((el, index) => (
                                <option key={index} value={JSON.stringify(el)}>
                                    {el.village}
                                </option>
                            ))}
                    </select>

                </div>
            </div>

            <div className="ml-auto flex flex-row">
                <div className="flex justify-between items-center">
                    {filters.district?.district_id && (
                        <a
                            className="ml-4 text-xs font-bold underline text-blue-700c cursor-pointer"
                            onClick={handleDownload}
                        >
                            <img src={csv} alt="csv" />
                        </a>
                    )}
                    {filters.district?.district_id && <GraphModal />}
                </div>

                {filters.district?.district_id && (
                    <div className="flex justify-between items-center gap-3">
                        <p className="w-68 p-2 text-[12px] rounded-md focus:outline-none text-[#1976D2  ] bg-gray-100">
                            <span className="font-bold">
                                Avg. {filters.crop !== "Apple" ? "sowing " : "pruning "}window:{" "}
                            </span>
                            <span className="text-gray-900">{sowingDate}</span>
                        </p>
                    </div>
                )}
            </div>
          {noData && (
            <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-black bg-opacity-30">
              <div className="bg-white p-5 rounded shadow-lg w-130 text-center z-[10000]">
                <p className="text-gray-700">{noDataMessage}</p>
                <button
                  className="mt-10 bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={() => setNoData(false)}
                >
                  OK
                </button>
              </div>
            </div>
          )}
        </div>
    );
}

export default Options;
